import { JSX } from 'react';
export const BackIcon = (): JSX.Element => {
  return (
    <svg
      className="icon__back"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Back"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6969 6.3157C15.1115 6.73482 15.1115 7.41186 14.6969 7.83097L10.5724 12.0007L14.6969 16.1704C15.1115 16.5895 15.1115 17.2665 14.6969 17.6857C14.2823 18.1048 13.6126 18.1048 13.198 17.6857L8.31875 12.7529C7.90417 12.3338 7.90417 11.6568 8.31875 11.2377L13.198 6.30495C13.602 5.89658 14.2823 5.89658 14.6969 6.3157Z"
        fill="#1c49c2"
      />
    </svg>
  );
};
